export enum SideBarDirection {
  Left = 'left',
  Right = 'right'
}
